export const FETCH_CREATED_SEGMENTS = 'FETCH_CREATED_SEGMENTS';
export const FETCH_CREATED_SEGMENTS_SUCCESS = 'FETCH_CREATED_SEGMENTS_SUCCESS';
export const FETCH_CREATED_SEGMENTS_ERROR = 'FETCH_CREATED_SEGMENTS_ERROR';

export const CREATE_CLONE = 'CREATE_CLONE';
export const CREATE_CLONE_SUCCESS = 'CREATE_CLONE_SUCCESS';
export const CREATE_CLONE_ERROR = 'CREATE_CLONE_ERROR';
